export default {
    apikeyNeo(state){
        return (state.totemObj) ? state.totemObj.apikey : null
    },
    centroNeo(state){
        return (state.totemObj) ? state.totemObj.centro : null
    },
    urlNeo(state){
        return (state.totemObj) ? state.totemObj.url : null
    }
}